<template>
  <section>
    <!--<header class="mui-bar mui-bar-nav">-->
    <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
    <!--<h1 class="mui-title">卷详情（{{ddqf=='1'?'机织':'AB'}}）</h1>-->
    <!--</header>-->
    <div class="mui-content pd-8">
      <div class="title-name">
        <span class="">卷详情（{{ddqf=='1'?'机织':'AB'}}）</span>
      </div>
      <!--基础信息-->
      <div class="sampling-first" style="border-bottom: 1px dashed #CCCCCC;margin-top: 15px;">
        <!--第一行-->
        <div class="sampling-first-title">
          <h4>基础信息</h4>
        </div>
        <!--第二行内容-->
        <div class="sampling-first-content">
          <!--第2行-->
          <div style="display: flex;padding-top: 0px;padding-bottom: 3px;">
            <div class="flex-1" style="font-size: 13px; display: flex;">
              <div class="sampling-first-content-left" style="flex: 0;text-align: left;min-width: 50px;padding-left: 12px;">
                <span>物料:</span>
              </div>
              <div class="flex-3" style="white-space: nowrap;">
                <span>{{scxtwph}} {{scxtwpmc}}</span>
              </div>
            </div>
            <div class="flex-1" style="font-size: 13px;display: flex;padding-top: 0px;padding-bottom: 3px;">
              <div class="sampling-first-content-left" style="flex: 0;text-align: left;min-width: 75px;padding-left: 12px;">
                <span>已检数量:</span>
              </div>
              <div class="flex-3">
                <span>{{yjsl}}{{dw}}</span>
              </div>
            </div>
          </div>
          <!--第1行-->
          <div style="font-size: 13px;padding-top: 0px;padding-bottom: 3px;">
            <div class="sampling-first-content-left" style="flex: 0;text-align: left;min-width: 75px;padding-left: 12px;">
              <span>外注订单:</span>
            </div>
            <div class="flex-9">
              <span>{{ddh}}</span>
            </div>
          </div>
          <!--第2行-->
          <div style="font-size: 13px;padding-top: 0px;padding-bottom: 3px;" v-if="iscj && (shipmentno&&shipmentno!='')">
            <div class="sampling-first-content-left" style="flex: 0;text-align: left;min-width: 75px;padding-left: 12px;">
              <span>出库单号:</span>
            </div>
            <div class="flex-9">
              <span>{{shipmentno}}</span>
            </div>
          </div>
          <div style="font-size: 13px;padding-top: 0px;padding-bottom: 3px;" v-else>
            <div class="sampling-first-content-left" style="flex: 0;text-align: left;min-width: 75px;padding-left: 12px;">
              <span>订单数量:</span>
            </div>
            <div class="flex-9">
              <span>{{sl}}{{dw}}</span>
            </div>
          </div>
          <!-- 2025 0A 0002 质检标签添加剩余未打卡量展示 ↓ -->
          <div style="font-size: 14px;padding-top: 0px;padding-bottom: 3px;display: block;" class="hover-container">
            <div style="flex-grow: 1;display:flex">
              <div style="color: #333333;width:110px;"><!-- class="sampling-first-content-left" -->
                <span>订单未打卡数量:</span>
              </div>
              <div style="width:calc(100% - 110px);">
                <span>{{sysl}}{{dw}}</span>
                <span class="mui-icon mui-icon-info hover-trigger" style="font-size:20px;color:#1F6FB5" ></span>
              </div>
            </div>
            <div style="flex-grow: 1;font-size: 14px;padding-top: 0px;padding-bottom: 3px;margin-top:3px;" class="hover-content">
              <div class="hover-reveal" style="width:100%">订单未打卡数量 = 订单量 - TSD实际入库量（包含系统入库和无系统入库） - 生产未出库量 - 在途量</div>
            </div>
          </div>
          <!-- 2025 0A 0002 质检标签添加剩余未打卡量展示 ↑ -->
        </div>
      </div>
      <div class="sampling-first">
        <div style="padding-top: 10px;position: relative">
          <span style="font-size: 25px;font-weight: bold;position: absolute;right: -1px;top: 15px;" v-if="(ddqf=='1'&&iscj)&&!readonly" @tap="scanQRCode"><img src="/static/images/richsacn.png" style="width:30px;"></span>
          <!--第一行-->
          <div class="form-group">
            <div class="input-label">
              <label>织机机台：</label>
            </div>
            <div class="form-input">
              <input type="text" maxlength="10" v-model="machineno" :disabled="!((mode=='add')&&!iscj)" @blur.prevent="toUpperCase('machineno')"/>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>坯布品番：</label>
            </div>
            <div class="form-input">
              <select v-model="clothcodeinfo" v-show="(mode=='add')&&!iscj"  @change="getclothQF">
                <option :value="item" v-for="(item,idx) in clothcodeLst" :key="idx">{{item.pbph}}</option>
              </select>
              <input type="text" v-model="clothcode" disabled v-show="!((mode=='add')&&!iscj)"/>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>轴号：</label>
            </div>
            <div class="form-input">
              <input type="text" maxlength="20" v-model="rollernumber" :disabled="!((mode=='add')&&!iscj)" @blur.prevent="toUpperCase('rollernumber')"/>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>{{ddqf=='1'?'外注卷号':'反番号'}}：</label>
            </div>
            <div class="form-input">
              <input type="text" maxlength="20" v-model="wzrollno" :disabled="!((mode=='add')&&!iscj)" @blur.prevent="toUpperCase('wzrollno')"/>
            </div>
          </div>
          <div class="form-group" v-if="ddqf=='1'">
            <div class="input-label">
              <label>坯布区分：</label>
            </div>
            <div class="form-input">
              <select v-model="clothremakflg" :disabled="!((mode=='add')&&!iscj)" >
                <option :value="item.sname" v-for="(item,idx) in codeLst" :key="idx">{{item.sname}}</option>
              </select>
              <!-- <input type="text" maxlength="10" v-model="clothremakflg" :disabled="!((mode=='add')&&!iscj)" /> -->
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>匹数：</label>
            </div>
            <div class="form-input">
              <input type="text" maxlength="8" v-model="boltnum" :disabled="!((mode=='add')||(iscj&&mode!='read'))" /><!--2019.12.06  抽检模式下，匹数不可变 -》调整为可变 -->
            </div>
          </div>
          <div class="form-group">
            <label class="input-label">长度：</label>
            <div class="form-input" style="display: flex;">
              <input type="text" style="flex:6;" maxlength="8" v-model="length" :disabled="(!((mode=='add')||(mode=='edit')||(iscj&&mode!='read'))) || (cjgrade!='' && !iscj)" /><!--2019.12.06  抽检模式下，米数不可变 -》调整为可变 -->
              <span class="input-label" style="flex:3;text-align: left;box-sizing: border-box;padding-left: 10px;">
                {{dw}}
              </span>
            </div>
          </div>
          <div class="form-group">
            <label class="input-label">等级：</label>
            <div class="form-input" style="display: flex;">
              <select style="flex: 5;" v-model="grade" :disabled="(!((mode=='add')||(mode=='edit'&&!pd)||(iscj&&mode!='read'))) || (cjgrade!='' && !iscj)">
                <option value="A">A</option>
                <option value="B">悬念反</option>
                <option value="C">C</option>
              </select>
              <span class="input-label" style="flex:3;"></span>
            </div>
          </div>
          <div class="form-group" v-if="grade=='B'">
            <label class="input-label" style="flex: 4;">悬念反原因：</label>
            <div class="form-input" style="flex: 9;display: flex;">
              <select style="flex: 5;" v-model="breason" :disabled="(!((mode=='add')||(mode=='edit'&&!pd)||(iscj&&mode!='read'))) || (cjgrade!='' && !iscj)">
                <option :value="item.scode" v-for="(item,idx) in breasonLst" :key="idx">{{item.sname}}</option>
              </select>
              <span class="input-label" style="flex:3;">
              </span>
            </div>
          </div>
          <div class="form-group" v-if="grade=='B'">
            <label class="input-label" style="flex: 4;">悬念反处置：</label>
            <div class="form-input" style="flex:9;display: flex;">
              <select style="flex: 5;" v-model="bdoresult" :disabled="(!((mode=='add')||(mode=='edit'&&!pd)||(iscj&&mode!='read'))) || (cjgrade!='' && !iscj)">
                <option :value="item.scode" v-for="(item,idx) in bdoresultLst" :key="idx">{{item.sname}}</option>
              </select>
              <span class="input-label" style="flex:3;"></span>
            </div>
          </div>
          <div class="form-group">
            <label class="input-label">落布日期：</label>
            <div class="form-input" style="display: flex;">
              <input type="text" style="flex: 5;" id="pickDateBtn" :data-options='dataoptions' v-model="fallingtime" @tap="showpicker" :disabled="!((mode=='add')&&!iscj)" />
              <span class="input-label" style="flex:3;"></span>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>备注：</label>
            </div>
            <div class="form-input" style="display: flex;">
              <textarea rows="3" maxlength="10" v-model="remark" :disabled="!((mode=='add')&&!iscj)"></textarea>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>备注1：</label>
            </div>
            <div class="form-input" style="display: flex;">
              <textarea rows="3" maxlength="250" v-model="remark1" :disabled="!((mode=='add')&&!iscj)"></textarea>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>备注2：</label>
            </div>
            <div class="form-input" style="display: flex;">
              <textarea rows="3" maxlength="250" v-model="remark2" :disabled="!((mode=='add')&&!iscj)"></textarea>
            </div>
          </div>
          <div class="form-group" v-if="mode!='read'">
            <label class="input-label">标签设备：</label>
            <div class="form-input" style="display: flex;">
              <select v-model="device">
                <option :value="item" v-for="(item,idx) in deviceLst" :key="idx">{{item.f_dvname}}</option>
              </select>
              <span class="input-label" style="flex:3;">
              </span>
            </div>
          </div>
          <div class="form-group" style="width:100%;margin-top: 5px;margin-bottom: 10px;">
            <button type="button" class="mui-btn mui-btn-primary btn-blue" style="margin: auto;width: 80px;" v-if="mode!='read'" @tap="finish">完成</button>
            <button type="button" class="mui-btn mui-btn-default" style="margin: auto;width: 80px;" v-if="(mode=='add')&&!iscj" @tap="conadd">继续添加</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "qualityDetail",
  data() {
    return {
      ddh: "",
      wph: "",
      scxtwph: "",
      scxtwpmc: "",
      yjsl: "",
      sl: "",
      dw: "",
      ddqf: "",
      tsdrollno: "",
      machineno: "", // 织机机台
      clothcode: "", // 坯布品番
      clothcodeinfo: null,
      clothcodeLst: [],
      rollernumber: "", // 轴号
      wzrollno: "", // 外注卷号
      boltnum: "", // 匹数
      clothremakflg: "", // 坯布区分
      length: "", // 长度
      grade: "", // 等级
      breason: "", // 悬念反原因
      breasonLst: [],
      bdoresult: "", // 悬念反处置
      bdoresultLst: [],
      fallingtime: "", // 落布时间
      remark: "", // 备注
      mode: "", // mode add edit read
      shipmentno: "",
      iscj: false, // 是否抽检
      statusflg: "", // 状态 0：质检登录 可编辑
      //dataoptions:'{"type":"date"}', // 年视图(年月日)
      dataoptions:'{"type":"datetime"}',// 完整日期视图(年月日时分)
      ksbh: "",
      deviceLst: [],
      device: null,
      fname: "",
      pd: false, // 判定
      idx: "",
      readonly: false,
      zdflg: false, // 是否已指定
      old_grade: "",
      old_breason: "",
      old_bdoresult: "",
      codeLst: [],// 坯布区分
      breadth: "",// 幅宽
      gauge_length: "",// 规格幅长  
      fkdw: "",// 幅宽单位  
      fcdw: "",// 幅长单位
      bcc: "",// 编成长
      bccdw: "",// 编成长单位
      bzzl: "",// 标准重量  
      pbcf: "",// 坯布成分  
      remark1: "",// 备注1
      remark2: "",// 备注2
      zjlrzt: "",// 质检录入状态
      dbph: "",// 代表品号
      pbpm: "",// 坯布品名
      old_boltnum:"", // 抽检模式_匹数原始值
      old_length:"", // 抽检模式下_TSD卷号原始值
      cjgrade:"",
      sysl:"" // 20250808 剩余打卡数量
    }
  },
  created() {
    this.nyy.wxInit();
  },
  activated() {
    var v = this;
    const para = getJsonPara(v.$route);
    if (para) {
      v.ddh = para.ddh;
      v.wph = para.wph;
      v.ksbh = para.ksbh;
      // 抽检
      if (para.iscj) {
        v.shipmentno = para.shipmentno;
        v.idx = para.idx;
        v.readonly = para.readonly;
        v.iscj = true;
      } else {
        v.shipmentno = "";
        v.iscj = false;
      }
      // 模式 新增、编辑
      if (para.tsdrollno) {
        v.tsdrollno = para.tsdrollno;
      } else {
        v.mode = "add";
        v.tsdrollno = "";
      }
      v.getJDetail();
    }
  },
  watch: {
    machineno: function(val) {
      var value = isZMSZ(val);
      var str = (value).toUpperCase();
      str = str.replace(/I/g, '').replace(/O/g, '');
      this.machineno = str;
    },
    rollernumber: function(val) {
      this.rollernumber = (val).toUpperCase();
    },
    wzrollno: function(val) {
      this.wzrollno = (val).toUpperCase();
    },
    // clothremakflg: function(val) {
    //   this.clothremakflg = isText(val);
    // },
    boltnum: function(val) {
      this.boltnum = isfloat(val);
    },
    length: function(val) {
      this.length = isfloat(val);
    }
  },
  methods: {
    // 返回一个字符串，该字符串中的所有字母都被转化为大写字母
    toUpperCase(name){
      var v = this;
      if(name == 'machineno'){
        v.machineno = (v.machineno).toUpperCase();
      }else if(name == 'rollernumber'){
        v.rollernumber = (v.rollernumber).toUpperCase();
      }else{
        v.wzrollno = (v.wzrollno).toUpperCase();
      }

      // 2019.12.04 机织或者AB的场合，若是机台输入后，默认显示上一次录入的轴号等信息
      if(name == 'machineno'){
         // 根据订单号和物料代码以及机台号，到数据库中查找最新录入的记录
         if(v.rollernumber == ''){
            v.getLastRollInfo();
         }
      }

      // AB反番号 自动生成
      if(v.ddqf == '3'){
        if(name == 'machineno' || name == 'rollernumber'){
          if(v.machineno!='' && v.rollernumber!='' ){ // && v.wzrollno == ''
            // 接口返回生成反番号
            v.getFFH();
          }
        }
      }
    },
    getLastRollInfo(){ // 获取上一次的输入值
      var v = this;
      v.nyy.doPost("/Quality/getLastInput", {
        "machineno": v.machineno,
        "ddh": v.ddh,
        "wph": v.wph,
        "ddqf": v.ddqf
      }, function(result) {
        if (result.status) {
          var lastRollLst = result.data.lastRollLst;
          if(lastRollLst.length >0){
            var rollinfo = lastRollLst[0];
            // 轴号
            v.rollernumber = rollinfo.rollernumber;
            // 品号
            if(v.clothcodeLst && v.clothcodeLst.length >0){
              v.clothcode = rollinfo.clothcode;
              v.getpbph();
            }
            // AB模式下，会自动获取轴号
            if(v.ddqf == '3' && v.machineno!='' && v.rollernumber!='' && v.wzrollno == ''){
              // 接口返回生成反番号
              v.getFFH();
            }
          }
        } else {
          mui.toast(result.message);
        }
      });
    },
    // 获取反番号
    getFFH(){
      var v = this;
      v.nyy.doPost("/Quality/getFFH", {
        "machineno": v.machineno,
        "rollernumber": v.rollernumber
      }, function(result) {
        if (result.status) {
          v.wzrollno = result.data.ffh;
        } else {
          mui.toast(result.message);
        }
      });
    },
    changeBoltnum(){
      var v = this;
      if(v.ddqf=='1'){
        if(v.clothcodeinfo && v.length!= ""){
          v.boltnum = (parseFloat(v.length)/parseFloat(v.clothcodeinfo.gcfc)).toFixed(2);
        }
      }
    },
    setinfo(){
      var v = this;
      v.breadth = v.clothcodeinfo?v.clothcodeinfo.gcfk:"";// 幅宽
      v.gauge_length = v.clothcodeinfo?v.clothcodeinfo.gcfc:"";// 规格幅长  
      v.fkdw = v.clothcodeinfo?v.clothcodeinfo.fkdw:"";// 幅宽单位  
      v.fcdw = v.clothcodeinfo?v.clothcodeinfo.fcdw:"";// 幅长单位
      v.bcc = v.clothcodeinfo?v.clothcodeinfo.bcc:"";// 编成长
      v.bccdw = v.clothcodeinfo?v.clothcodeinfo.bccdw:"";// 编成长单位
      v.bzzl = v.clothcodeinfo?v.clothcodeinfo.bzzl:"";// 标准重量  
      v.pbcf = v.clothcodeinfo?v.clothcodeinfo.pbcf:"";// 坯布成分  
      v.dbph = v.clothcodeinfo?v.clothcodeinfo.dbph:"";// 代表品号
      v.pbpm = v.clothcodeinfo?v.clothcodeinfo.pbpm:"";// 坯布品名
    },
    getpbph() {
      var v = this;
      for (var i = 0; i < v.clothcodeLst.length; i++) {
        if (v.clothcode == v.clothcodeLst[i].pbph) {
          v.clothcodeinfo = v.clothcodeLst[i];
          return;
        }
      }
    },
    getclothQF(){ // 获取品番的坯布区分
      var v = this;
      var pbph = v.clothcodeinfo ? v.clothcodeinfo.pbph : "";
      if(v.ddqf != '1' || (v.ddqf == '1' && pbph == "")) return;
      // 查询
      v.clothQF(pbph,"add");
    },
    clothQF(pbph,type){
      var v = this;
      v.nyy.doPost("/Quality/getClothQF", {
          pbph: pbph
        },
        function(result) {
          if (result.status) {
             v.codeLst = result.data.codeLst;
             if(type == "add"){
                if(v.codeLst && v.codeLst.length>0){
                  v.clothremakflg = v.codeLst[0]["sname"]; // 坯布区分
                }else{
                  v.clothremakflg = ""; // 坯布区分
                }
             }
          }
        });
    },
    getclothQFRead(){
        var v = this;
        if(v.ddqf != '1' || (v.ddqf == '1' && v.clothcode == "")) return;
        // 查询
        v.clothQF(v.clothcode,"read");
    },
    getJDetail() {
      var v = this;
      v.nyy.doPost("/Quality/getJDetail", {
          ddh: v.ddh,
          wph: v.wph,
          tsdrollno: v.tsdrollno
        },
        function(result) {
          if (result.status) {
            var info = result.data.info;
            v.scxtwph = info.scxtwph;
            v.scxtwpmc = info.scxtwpmc;
            v.sl = info.sl;
            v.dw = info.dw;
            v.yjsl = info.yjsl;
            v.ddqf = info.ddqf;
            // 质检录入状态
            v.zjlrzt = info.zjlrzt;
            v.fname = info.fname;
            v.breasonLst = result.data.breasonLst;
            v.bdoresultLst = result.data.bdoresultLst;
            // todo 坯布区分
            if(v.ddqf == '1'){
              //v.codeLst = result.data.codeLst;
            }

            // 坯布品番
            v.clothcodeLst = result.data.pbphInfoList;
            //v.clothcodeLst = [{"pbph":"WZ3450","gcfc":50.0,"bzzl":6.23,"fcdw":"M","pbcf":"PE100","gcfk":148.0,"fkdw":"C","bcc":1.0,"bccdw":"M","dbph":"WZ1230","pbpm":"国内丸编"},{"pbph":"WZ3450-1","gcfc":50.0,"bzzl":0.01,"fcdw":"M","pbcf":"PE100","gcfk":148.0,"fkdw":"C","bcc":1.0,"bccdw":"M","dbph":"WZ1230","pbpm":"国内丸编"}];//result.data.pbphInfoList;

            v.deviceLst = result.data.deviceLst;
            v.device = (v.deviceLst && v.deviceLst.length > 0) ? v.deviceLst[0] : null;

            // 20250811 剩余未打卡数量 ↓
            // v.sysl = info.sysl;
            // 20250811 剩余未打卡数量 ↑


            if (v.mode == "add" && v.tsdrollno == "") {
              v.machineno = ""; // 织机机台
              v.clothcode = ""; // 坯布品番
              v.rollernumber = ""; // 轴号
              v.pd = false;
              v.clothcodeinfo = (v.clothcodeLst && v.clothcodeLst.length > 0) ? v.clothcodeLst[0] : null;
              v.init();
              v.zdflg = false;
              v.old_grade = "";
              v.old_breason = "";
              v.old_bdoresult = "";
            } else {
              v.machineno = info.machineno; // 织机机台
              v.clothcode = info.clothcode; // 坯布品番
              v.getpbph();
              v.rollernumber = info.rollernumber; // 轴号
              v.wzrollno = info.wzrollno; // 外注卷号
              v.boltnum = info.boltnum; // 匹数
              v.old_boltnum = info.boltnum; // 抽检模式_匹数原始值
              v.getclothQFRead();
              v.clothremakflg = info.clothremakflg; // 坯布区分
              v.length = info.length; // 长度
              v.old_length = info.length; // 抽检模式下_TSD卷号原始长度值
              v.cjgrade  = (!info.cjgrade) ? "" : info.cjgrade;
              v.grade = !v.iscj ? info.grade : info.cjgrade; // 等级
              v.old_grade = !v.iscj ? info.grade : info.cjgrade; // 等级
              if(v.iscj && (!info.cjgrade || info.cjgrade == "")){
                v.old_grade = info.grade;
              }
              v.breason = !v.iscj ? info.breason : info.cjbreason; // 悬念反原因
              v.old_breason = !v.iscj ? info.breason : info.cjbreason;
              if(v.iscj && (!info.cjbreason || info.cjbreason == "")){
                v.old_breason = info.breason;
              }
              v.bdoresult = !v.iscj ? info.bdoresult : info.cjbdoresult; // 悬念反处置
              v.old_bdoresult = !v.iscj ? info.bdoresult : info.cjbdoresult;
              if(v.iscj && (!info.cjbdoresult || info.cjbdoresult == "")){
                v.old_bdoresult = info.bdoresult;
              }
              v.fallingtime = info.fallingtime; // 落布时间
              v.remark = info.remark; // 备注
              v.remark1 = info.remark1;// 备注1
              v.remark2 = info.remark2;// 备注2
              v.pd = info.pd;
              v.statusflg = info.statusflg;
              v.zdflg = info.zdflg; // 是否已被指定
              // 0:质检登录
              if (v.statusflg == '0') {
                // 外注登录
                if (!v.iscj) {
                  v.mode = "edit";
                }else{
                  // TSD随机抽检
                  if((!v.shipmentno || v.shipmentno=="")&&info.cjgrade){
                    // 非在库只读
                    v.mode = "add";
                  }
                }
              } else {
                // 已指定同时不是抽检的情况下只读
                v.mode = "read";
                // 抽检模式下
                if(v.iscj && (v.statusflg == "1")){
                  //  1:指示明细 出库单号 非只读
                  if(!v.readonly&&(v.shipmentno && v.shipmentno!="")){
                    //if(v.idx && v.idx!=""){
                      //v.mode = "edit";
                    //}else{
                      v.mode = "add";
                    //}
                  }
                }
              }
              // AB质检录入状态
              if(v.zjlrzt == '01' && v.ddqf == '3'){
                v.mode = "read";
              }

              // 20250811 剩余未打卡数量 ↓
              v.getContractSYAmount();
              // 20250811 剩余未打卡数量 ↑
            }
            v.setinfo();
          }
        }
      );
    },
    init() {
      var v = this;
      v.wzrollno = ""; // 外注卷号
      v.boltnum = ""; // 匹数
      /*if(v.codeLst && v.codeLst.length>0){
        v.clothremakflg = v.codeLst[0]["sname"]; // 坯布区分
      }else{
        v.clothremakflg = ""; // 坯布区分
      }*/
      // 坯布区分
      v.getclothQF();
      v.length = ""; // 长度
      v.grade = "A"; // 等级
      v.breason = ""; // 悬念反原因
      v.bdoresult = ""; // 悬念反处置

      var date = new Date(); //获取当前时间
      var now_date = v.getFormatDate(date) + " " + v.GetDefalutTime();
      v.fallingtime = now_date; // 落布时间

      v.remark = ""; // 备注
      v.remark1 = "";// 备注1
      v.remark2 = "";// 备注2
      v.statusflg = "";
      // 获取剩余可打卡数量
      // 20250811 剩余未打卡数量 ↓
      v.getContractSYAmount();
      // 20250811 剩余未打卡数量 ↑
    },
    showpicker() {
      var v = this;
      var dDate = new Date();
      var optionsJson = v.dataoptions;
      var options = JSON.parse(optionsJson);
      var picker = new mui.DtPicker(options);
      picker.show(function(rs) {
        console.log(rs)
        var timestr = rs.text;
        v.fallingtime = timestr.replace(/-/g, "/");
        picker.dispose();
      });
    },
    GetDefalutTime(){
      // 获取系统时间
      var systemDate = new Date();
      var sysTime = "";
      if (systemDate.getHours() < 10) {
          sysTime += "0" + systemDate.getHours();
      } else {
          sysTime += systemDate.getHours();
      }
      if (systemDate.getMinutes() < 10) {
          sysTime += ":0" + systemDate.getMinutes();
      } else {
          sysTime += ":" + systemDate.getMinutes();
      }
      return sysTime;
    },
    getFormatDate(date) {
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    // 完成
    finish() {
      var v = this;
      if (v.mode == 'add') {
        if (!v.check()) return;
        if (!v.device) {
          mui.toast("请选择标签设备");
          return;
        }
        if (v.iscj) {
          var jcj_param = {
            grade: v.grade,
            breason: v.breason,
            bdoresult: v.bdoresult,
            tsdrollno: v.tsdrollno
          }
          // 若是等级发生变化
          if(v.length != v.old_length){
            jcj_param.length = v.length;
          }
          // 若是匹数发生变化
          if(v.boltnum != v.old_boltnum){
            jcj_param.boltnum = v.boltnum;
          }

          // 抽检
          v.addJCJ(jcj_param, function() {
            // 是否包含出库单号
            if(!(v.shipmentno && (v.shipmentno!=""))){
              if(v.old_grade == v.grade && v.old_bdoresult == v.bdoresult && v.length == v.old_length && v.boltnum == v.old_boltnum){// && v.old_breason == v.breason
                v.$router.replace({ "name": "qualityList", params: jsonPara({ "ksbh": v.ksbh, "ddh": v.ddh, "wph": v.wph }) });
              }else{
                v.printZJBQ(function(){
                  v.$router.replace({ "name": "qualityList", params: jsonPara({ "ksbh": v.ksbh, "ddh": v.ddh, "wph": v.wph }) });
                });
              }
            }else{
              v.printZJBQ();        
            }
          });
        } else {
          var postMap = v.setMap();
          // 机织
          if (v.ddqf != "1") {
            postMap.clothremakflg = "";
          }
          postMap.labelprinttime = ""; // 最终吊牌打印时间
          v.addJ(postMap, function() {
            v.printZJBQ();
          });
        }
      } else {
        if (v.iscj) {
          v.updateJCJ(function() {
            if(v.old_grade == v.grade){
              v.$router.go(-1);
            }else {
              v.printZJBQ();
            }
          });
        } else {
          v.updateJ(function() {
            v.printZJBQ();
          });
        }
      }
    },
    // 打印质检标签
    printZJBQ(callback) {
      var v = this;
      // C级不打吊牌
      if(v.grade == "C"){
        if(callback){
          callback();
        }else{
          v.$router.go(-1);
        }
        return;
      }
      var postMap = {
        "tsdrollno": v.tsdrollno, // TSD卷号
        "clothcode": v.clothcode, // 坯布品番 (坯布质检 - 坯布品番 )
        "wzrollno": v.wzrollno, // 外注卷号
        "clothremakflg": v.clothremakflg, // 坯布区分 机织的情况下使用
        "rollernumber": v.rollernumber, // 轴  号
        "boltnum": v.boltnum, // 匹    数
        "length": v.length, // 布  长
        "machineno": v.machineno, // 织机号
        "grade": (v.grade == 'B' ? '悬念反' : v.grade), // 等  级 (A、C、悬念反)
        "fallingtime": v.fallingtime, // 落布时间(yyyy年mm月dd日)
        "fname": v.fname, // 织布工厂 (供应商-简称 表中数据对应简称2)todo
        "bdoresult": v.bdoresult, // 色 区 分 (悬念反处置结果;若没有，固定值“无”)
        "remark": v.remark, // 备    注
        "ddqf": v.ddqf, // 订单区分
        "dvno": v.device.dvno // 终端编号
      };
      // AB
      if (v.ddqf != "1") {
        postMap.clothremakflg = "";
      }
      v.nyy.doPost("/Quality/printZJBQ", postMap,
        function(result) {
          if (result.status) {
            if(callback){
              callback();
            }else{
              v.$router.go(-1);
            }
          }
        }
      );
    },
    updateJ(callback) {
      var v = this;
      if (!v.checkgrade()) return;
      // 未采样判定的可编辑等级 长度
      var postMap = {
        "ddh": v.ddh,
        "wph": v.wph,
        "tsdrollno": v.tsdrollno,
        "grade": v.grade,
        "breason": v.breason,
        "bdoresult": v.bdoresult,
        "statusflg": v.statusflg,
        "length": v.length,
        "labelprinttime": ""
      };
      // 已判定的不可修改等级，只能修改长度
      if (v.pd) {
        postMap = {
          "ddh": v.ddh,
          "wph": v.wph,
          "tsdrollno": v.tsdrollno,
          "length": v.length
        };
      }
      v.nyy.doPost("/Quality/updateJ", postMap,
        function(result) {
          if (result.status) {
            if (callback) callback();
          } else {
            mui.toast(result.message);
          }
        }
      );
    },
    updateJCJ(callback) {
      var v = this;
      var postMap = {
        grade: v.grade,
        breason: v.breason,
        bdoresult: v.bdoresult,
        tsdrollno: v.tsdrollno,
        idx: v.idx
      };
      v.nyy.doPost("/Quality/updateJCJ", postMap,
        function(result) {
          if (result.status) {
            if (callback) callback();
          } else {
            mui.toast(result.message);
          }
        }
      );
    },
    check() {
      var v = this;
      if (v.machineno == "") {
        mui.toast("请输入织机机台");
        return false;
      }
      if (!v.clothcodeinfo) {
        mui.toast("请选择坯布品番");
        return false;
      }
      v.clothcode = v.clothcodeinfo.pbph;
      if (v.rollernumber == "") {
        mui.toast("请输入轴号");
        return false;
      }
      if (v.wzrollno == "") {
        if (v.ddqf == '1') {
          mui.toast("请输入外注卷号");
        } else {
          mui.toast("请输入反番号");
        }
        return false;
      }
      if(v.ddqf=='1'){
        if(v.clothremakflg==""){
          mui.toast("请选择坯布区分");
          return false;
        }
      }
      // 长度4位 包含一位小数
      if (v.boltnum == "") {
        mui.toast("请输入匹数");
        return false;
      }
      if (!is4SZ(v.boltnum)) {
        mui.toast("请输入合法匹数");
        return false;
      }
      if (parseInt(v.boltnum) > 99) {
        mui.toast("请输入合法匹数");
        return false;
      }
      if (v.length == "") {
        mui.toast("请输入长度");
        return false;
      }
      if (!is8SZ(v.length)) {
        mui.toast("请输入合法长度");
        return false;
      }
      if (parseInt(v.length) > 9999) {
        mui.toast("请输入合法长度");
        return false;
      }
      if (!v.checkgrade()) {
        return false;
      }
      if (v.fallingtime == "") {
        mui.toast("请输入落布时间");
        return false;
      }
      return true;
    },
    checkgrade() {
      var v = this;
      if (!v.grade || v.grade == "") {
        mui.toast("请选择等级");
        return false;
      }
      if (v.grade == 'B') {
        if (!v.breason || v.breason == "") {
          mui.toast("请选择悬念反原因");
          return false;
        }
        if (!v.bdoresult || v.bdoresult == "") {
          mui.toast("请选择悬念反处置");
          return false;
        }
      }else{
        v.breason = "";
        v.bdoresult = "";
      }
      return true;
    },
    setMap() {
      var v = this;
      var postMap = {
        "ddh": v.ddh,
        "wph": v.wph,
        "wzrollno": (v.wzrollno).toUpperCase(), // 外注卷号
        "machineno": (v.machineno).toUpperCase(), // 织机机台
        "rollernumber": (v.rollernumber).toUpperCase(), // 轴号
        "clothcode": v.clothcode, // 坯布品番
        "boltnum": v.boltnum, // 匹数
        "clothremakflg": v.clothremakflg, // 坯布区分 机织的情况下使用
        "length": v.length, // 长度
        "grade": v.grade, // 等级
        "breason": v.breason, // 悬念反原因
        "bdoresult": v.bdoresult, // 悬念反处置
        "fallingtime": v.fallingtime, // 落布时间
        "remark": v.remark, // 备注
        "statusflg": "0",
        "netweight": 0,
        "ksbh": v.ksbh,
        "ddqf": v.ddqf,
        "remark1": v.remark1,// 备注1
        "remark2": v.remark2// 备注2 
      };
      return postMap;
    },
    addJ(postMap, callback) {
      var v = this;
      // 新增字段
      v.setinfo();
      postMap.breadth = v.breadth;// 幅宽
      postMap.gauge_length = v.gauge_length;// 规格幅长  
      postMap.fkdw = v.fkdw;// 幅宽单位  
      postMap.fcdw = v.fcdw;// 幅长单位
      postMap.bcc = v.bcc;// 编成长
      postMap.bccdw = v.bccdw;// 编成长单位
      postMap.bzzl = v.bzzl;// 标准重量
      postMap.pbcf = v.pbcf;// 坯布成分 
      postMap.dbph = v.dbph;// 代表品号
      postMap.pbpm = v.pbpm;// 坯布品名

      v.nyy.doPost("/Quality/addJ", postMap,
        function(result) {
          if (result.status) {
            v.tsdrollno = result.data.tsdrollno;
            if (callback) callback();
          } else {
            mui.toast(result.message);
          }
        }
      );
    },
    // 新增抽检
    addJCJ(postMap, callback) {
      var v = this;
      v.nyy.doPost("/Quality/addJCJ", postMap,
        function(result) {
          if (result.status) {
            if (callback) callback();
          } else {
            mui.toast(result.message);
          }
        }
      );
    },
    // 继续添加
    conadd() {
      var v = this;
      if (!v.check()) return;
      if (!v.device) {
          mui.toast("请选择标签设备");
          return;
      }
      var postMap = v.setMap();
      // 机织
      if (v.ddqf != "1") {
        postMap.clothremakflg = "";
      }
      v.addJ(postMap, function() {
        v.printZJBQ(function(){
          v.init();
          // AB
          if(v.ddqf == '3'){
            v.getFFH();
          }
        });
      });
    },
    // 抽检模式下，直接扫描当前TSD二维码，获取信息后，表示
    scanQRCode() {
      //mui.toast('进入抽检扫码')
      var v = this;
      // 需校验当前扫码是否是该出库单号下指示的明细
      wx.scanQRCode({
        desc: 'scanQRCode desc',
        needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          // 回调
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          if (!result > 1) {
            mui.toast('无效二维码')
          } else {
            // 需校验当前扫码是否是该出库单号下指示的明细
            // TSD卷号截取，获取前8位 2020/06/28
            var rollstr = result.substr(0,8);
            v.tsdrollno = rollstr;
            //v.tsdrollno = result;
            if(v.shipmentno&&v.shipmentno!=''){
              v.checkMX(function() {
                v.getJDetail();
              });
            }else{
              v.getJDetail();
            }
          }
        },
        error: function(res) {
          //mui.toast(JSON.stringify(res));
          if (res.errMsg.indexOf('function_not_exist') > 0) {
            mui.toast('版本过低请升级')
          }
        }
      });
    },
    checkMX(callback) {
      var v = this;
      v.nyy.doPost("/Quality/checkMX", {
        "shipmentno": v.shipmentno,
        "tsdrollno": v.tsdrollno
      }, function(result) {
        if (result.status) {
          if (callback) callback();
        } else {
          mui.toast(result.message);
        }
      });
    },
    // 获取订单剩余数量
    getContractSYAmount(callback) {
      var v = this;
      v.nyy.doPost("/Quality/getContractSYAmount", {
        ddh: v.ddh,
        wph: v.wph
      },
      function(result) {
        if (result.status) {
          // 20250811 剩余未打卡数量 ↓
          v.sysl = result.data.info.sysl;
          // 20250811 剩余未打卡数量 ↑
          if (callback) callback();
        } else {
          mui.toast(result.message);
        }
      }
      );
    }
  }
}
</script>
<style scoped>
@import "../../static/css/sampling.css";
@import "../../static/css/samplinghistory.css";
@import "../../static/css/filterorder.css";
@import "../../static/css/quality.css";
</style>



// WEBPACK FOOTER //
// src/components/qualityDetail.vue